import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getRevisedTraumaScoreSelector } from '../selectors'
import { RevisedTraumaScoreConstants } from '../store/revisedTraumaScore.constants'
import { IRevisedTraumaScoreState } from '../store/revisedTraumaScore.types'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* saveRTS() {
  const rtsData: IRevisedTraumaScoreState = yield select(getRevisedTraumaScoreSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...rtsData,
      },
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveRTS() error: ${e}`))
    }
  }
}

export function* saveRTSSaga() {
  yield takeLatest([RevisedTraumaScoreConstants.SAVE_RTS_DATA], performWithMutexHOG, saveRTS)
}
